import React from 'react';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { useResizeDetector } from 'react-resize-detector';
import { useTheme } from '@mui/material/styles';
import { BarStore } from '@gamiphy/loyalty-station-desktop/store/ui/bar';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { FramePortal } from '@gamiphy/loyalty/components/framePortal';
import { getThemeFontStyleSheets } from '@gamiphy/loyalty/theme';
import BarContent from './BarContent';

const Bar: React.FC = observer(() => {
  const theme = useTheme();
  const {
    width,
    height,
    ref,
  } = useResizeDetector<HTMLDivElement>();

  React.useEffect(() => {
    if (width && height) {
      const domRect = ref.current?.getBoundingClientRect();
      BarStore.setDimensions({
        width,
        height,
      });

      if (domRect) {
        BarStore.setOffset({
          top: domRect?.top,
          left: domRect.left,
          right: domRect.right,
          bottom: domRect.bottom,
        });
      }
    }
  }, [width, height]);

  return (
    <div
      ref={ref}
      style={{
        width: '100%', height: '100%', position: 'relative', marginLeft: '0.5rem',
      }}
    >
      <FramePortal
        stylesheets={getThemeFontStyleSheets(ThemeStore.theme)}
        theme={theme}
        dir={AppStore.dir}
      >
        <BarContent />
      </FramePortal>
    </div>
  );
});

export default Bar;
